// import { useEffect } from 'react'
// import styles from './HorizontalWallet.module.sass'
// import CheckCircleOutlineRoundedIcon from '@mui/icons-material/CheckCircleOutlineRounded'
// import { RootState } from 'redux/store'
// import { useDispatch, useSelector } from 'react-redux'
// import { setShowAddWallet } from '../../redux/userReducer'
// import ToolTip from 'utils/ToolTip'
// 
// function HorizontalWallet() {
//   const wallets = useSelector((state: RootState) => state.user.wallets)
//   const dispatch = useDispatch()
//   useEffect(() => {
//     if (wallets?.length <= 0) {
//       dispatch(setShowAddWallet(true))
//     }
//   }, [wallets])
// 
//   return (
//     <div className={styles.container}>
//       {/* <ToolTip content="Your tooltip text"> */}
//       <div className={styles.title}>Wallet(s)</div>
//       {/* </ToolTip> */}
// 
//       {wallets.map((wallet, index) => {
//         return (
//           <div
//             style={{
//               marginLeft: 20,
//               cursor: 'default',
//             }}
//             className="button-wallet"
//           >
//             ****{(wallet as any).slice(-4)}
//             <CheckCircleOutlineRoundedIcon
//               style={{
//                 marginLeft: 15,
//               }}
//             />
//           </div>
//         )
//       })}
//     </div>
//   )
// }
// 
// export default HorizontalWallet
// 
// 
// 



import { useEffect } from 'react'
import styles from './HorizontalWallet.module.sass'
import CheckCircleOutlineRoundedIcon from '@mui/icons-material/CheckCircleOutlineRounded'
import { RootState } from 'redux/store'
import { useDispatch, useSelector } from 'react-redux'
import { setShowAddWallet } from '../../redux/userReducer'
import ToolTip from 'utils/ToolTip'

interface HorizontalWalletProps {
  showWallets?: boolean
}

function HorizontalWallet({ showWallets = true }: HorizontalWalletProps) {
  const wallets = useSelector((state: RootState) => state.user.wallets)
  const dispatch = useDispatch()
  
  useEffect(() => {
    if (wallets?.length <= 0) {
      dispatch(setShowAddWallet(true))
    }
  }, [wallets])

  // Don't render anything if showWallets is false
  if (!showWallets) {
    return null
  }
  
  // Don't render wallets display if no wallets (modal will show instead)
  if (!wallets || wallets.length === 0) {
    return null
  }
  
  return (
    <div className={styles.container}>
      {wallets.map((wallet, index) => {
        return (
          <div
            key={index}
            style={{
              marginLeft: index === 0 ? 0 : 20,
              cursor: 'default',
            }}
            className="button-wallet"
          >
            ****{(wallet as any).slice(-4)}
            <CheckCircleOutlineRoundedIcon
              style={{
                marginLeft: 15,
              }}
            />
          </div>
        )
      })}
    </div>
  )
}

export default HorizontalWallet